export const ID = '7afb392e-1d71-48e6-b82c-2d0c34d9e954';

export const NAME = 'Facility Sale Banner';
